<template>
  <BContainer
    v-if="currentUser"
    class="mb-4 px-0"
    fluid
  >

    <div class="py-2 w-100 border-bottom font-weight-bold text-muted mb-3">
      <div class="d-flex justify-content-between align-items-center">
        <div>Memo Cascading this {{ monthLongFormatter(schedule) }}</div>
        <div>
          <BButton
            size="sm"
            variant="link"
            :to="{
              name: 'fso.to-dos.customer-memos.pending'
            }"
          >
            <i class="far fa-circle-arrow-right fa-lg m-0 p-0" />
          </BButton>
        </div>
      </div>
    </div>

    <BRow
      v-if="busy"
      class="my-3"
    >
      <BCol
        cols="12"
      >
        <div class="text-center py-5">
          <BIcon
            icon="stopwatch"
            font-scale="5"
            animation="cylon"
          />
          <p class="h6 py-2">
            <strong>Loading . . .</strong>
          </p>
        </div>
      </BCol>
    </BRow>

    <BRow
      v-else-if="customerMemos.length === 0"
    >
      <BCol
        cols="12"
        class="text-center py-5"
      >
        <BIcon
          icon="calendar"
          font-scale="4"
        />
        <p class="h6 py-2">
          <strong>No customer memo found</strong>
        </p>
      </BCol>
    </BRow>

    <BRow
      class="gap-y-2 mb-3 px-2"
    >
      <BCol
        v-for="(customerMemo, index) in customerMemos"
        :key="index"
        cols="12"
        md="4"
        class="px-1"
      >
        <CustomerMemo
          class="rounded-sm"
          :memo="{
            memo_name: customerMemo.memo_name,
            valid: customerMemo.customer_memos_valid_count,
            invalid: customerMemo.customer_memos_invalid_count
          }"
          :current-progress="{
            event: customerMemo.customer_memos_closed_count
          }"
          :total-progress="{
            event: customerMemo.customer_memos_assigned_count
          }"
        />
      </BCol>
    </BRow>

  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'
import MxImageUrl from '@/mixins/image-url'

import CustomerMemo from '@/views/fso/dashboards/components/CustomerMemoCircle.vue'

export default {
  name: 'FSODashboardCustomerMemos',

  components: {
    CustomerMemo
  },

  mixins: [
    MxMisc,
    MxFormatter,
    MxImageUrl
  ],

  props: {
    busy: {
      type: Boolean,
      required: true,
      default: false
    },
    schedule: {
      type: String,
      required: true,
      default: ''
    },
    customerMemos: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  computed: mapGetters({
    currentUser: 'auth/user'
  })
}
</script>
